<script setup lang="ts">
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    :label-style="{ width: '15%' }"
    style="margin-top: 24px"
    bordered
  >
    <a-descriptions-item label="Agência" :span="3">
      {{ props.compromisso.data.agencia }}
    </a-descriptions-item>
    <a-descriptions-item label="Conta" :span="3">
      {{ props.compromisso.data.conta }}
    </a-descriptions-item>
    <a-descriptions-item label="Carteira" :span="3">
      {{ props.compromisso.data.carteira }} </a-descriptions-item
    ><a-descriptions-item label="Contrato" :span="3">
      {{ props.compromisso.data.contrato }}
    </a-descriptions-item>
  </a-descriptions>
</template>
